import styled from "styled-components";

interface OmvProps {
  omv: {
    thumb: string;
    title: string;
    html: string;
  }
}

export function Omv({ omv }: OmvProps) {
  return (
    <OmvItem>
      <OmvImg src={omv.thumb} />
      <OmvTitle>{omv.title}</OmvTitle>
      <OmvContent dangerouslySetInnerHTML={{__html: omv.html}} />
    </OmvItem>
  );
}

const OmvItem = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const OmvImg = styled.img`
  display: block;
  width: 230px;
  height: auto;
  margin: auto;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 200px;
  }
`;

const OmvTitle = styled.span`
  display: inline-block;
  text-transform: uppercase;
  margin: auto;
  color: #fff;
  font-size: 42px;
  padding: 0 12px;
  background-color: ${({ theme }) => theme.colors.blue.dark};
  transform: translateY(50%);
  z-index: 1;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 36px;
  }
`;

const OmvContent = styled.div`
  height: 364px;
  border-radius: 16px;
  padding: 32px;
  margin: 0 8px;
  font-size: 22px;
  text-align: center;
  position: relative;
  color: ${({ theme }) => theme.colors.blue.dark};
  border: ${({ theme }) => `2px solid ${theme.colors.blue.dark}`};

  > p {
    width: calc(100% - 64px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  > ul {
    width: calc(100% - 32px);
    position: absolute;
    top: 50%;
    right: 0;
    line-height: 1.5;
    text-align: left;
    padding-left: 12px;
    transform: translateY(-50%);
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 18px;
    height: 280px;
    margin: 0 auto 32px;
    max-width: 600px;
    width: calc(100% - 32px);
    
    > ul {
      list-style-position: inside;
    }
  }
`;